import { RotateCcw } from "lucide-react";

export const DemoToolbar = ({ onSimulate, onReset }) => (
  <div
    data-testid="demo-toolbar"
    className="w-full flex items-center justify-center gap-1.5 font-mono-label"
  >
    <span className="text-[9px] uppercase tracking-[0.2em] text-[#A8A29E] mr-1.5">
      Demo
    </span>
    {[1, 3, 5].map((n) => (
      <button
        key={n}
        type="button"
        data-testid={`demo-simulate-${n}`}
        onClick={() => onSimulate(n)}
        className="text-[10px] uppercase tracking-widest text-[#57534E] border border-[#E7E2D7] rounded-full px-2.5 py-1 bg-white/60 hover:border-[#C25E38]/40 hover:text-[#C25E38] transition-colors duration-200 cursor-pointer"
      >
        {n} ★
      </button>
    ))}
    <button
      type="button"
      data-testid="demo-reset-button"
      onClick={onReset}
      aria-label="Reiniciar demo"
      className="text-[#A8A29E] border border-[#E7E2D7] rounded-full p-1.5 bg-white/60 hover:text-[#C25E38] hover:border-[#C25E38]/40 transition-colors duration-200 cursor-pointer"
    >
      <RotateCcw className="h-3 w-3" />
    </button>
  </div>
);
